import { useSelector } from 'react-redux'
import { selectEventAlertsListStructure } from '@/features/domain/lists'

import { useEditingStateWithCtx } from '@/atoms'
import { useFilterList } from './useFilterList'
import { useSearchList } from './useSearchList'

export function useFilter() {
  const { editing } = useEditingStateWithCtx('alert')
  const { query, setQuery } = useSearchList()
  const listStructure = useSelector(selectEventAlertsListStructure)
  const { filter, setFilter } = useFilterList()

  return {
    query,
    filter,
    editing,
    setQuery,
    setFilter,
    noEntries: listStructure.totalItems === 0,
  }
}
